import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Miraroadtopunecab() {



  const cardData = {


  keyword: "Mira Road to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Mira Road to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, industrial visits, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a comfortable journey from Mira Road to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, clean and well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Mira Road to Pune taxi services.",

  topPlaces: [
   {
      title: "Alibaug",
      description: "Alibaug is a coastal getaway near Mumbai famous for beaches, forts, resorts, and relaxing vacations. It is a preferred weekend destination for families and groups traveling from Pune."
    },
    {
      title: "Matheran",
      description: "Matheran is a peaceful hill station near Mumbai known for scenic viewpoints, lush greenery, and a pollution-free environment. It is a popular nature destination for weekend travelers."
    },
     {
      title: "Mumbai Airport",
      description: "Mumbai Airport is a major pickup and drop location for passengers traveling between Mira Road and Pune. Cab services are preferred for comfortable airport transfers with luggage and timely travel."
    },
    {
      title: "Bandra",
      description: "Bandra is one of Mumbai's premium destinations known for corporate offices, luxury hotels, restaurants, shopping areas, and entertainment hubs. It is a popular stop and destination for Mumbai-Pune cab travelers."
    },
    {
      title: "Navi Mumbai",
      description: "Navi Mumbai is a growing commercial and residential hub featuring corporate offices, industrial areas, business parks, and modern infrastructure. It is a common destination for Pune outstation taxi services."
    },
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's leading technology destination, home to multinational companies, IT firms, and corporate campuses. It is one of the most requested locations for business travelers from Mumbai."
    },
    {
      title: "Kharadi",
      description: "Kharadi is Pune's major IT and commercial hub featuring EON IT Park, corporate offices, hotels, and business centers. It is a preferred destination for professionals requiring reliable cab services."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is a major industrial and commercial region known for automobile companies, manufacturing units, engineering industries, and corporate establishments."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station located between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and green valleys. It is a popular weekend destination for families and tourists."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a beautiful hill station near Pune known for strawberry farms, scenic viewpoints, lakes, and waterfalls. It is a popular destination for comfortable outstation cab trips."
    },
    
  ],





"services": [
  {
    "name": "Pune to Mira Road Cab",
    "description": "Book Pune to Mira Road Cab for comfortable intercity travel with experienced chauffeurs, clean AC vehicles, fixed fares, doorstep pickup, luggage assistance, and reliable one way or round trip cab services."
  },
  {
    "name": "Bhayandar to Pune Cab",
    "description": "Choose Bhayandar to Pune Cab for safe and affordable travel with professional drivers, Sedan, Ertiga, Innova, and SUV options, transparent pricing, and 24x7 booking support."
  },
  {
    "name": "Bhayandar to Pune Cab Service",
    "description": "Book Bhayandar to Pune Cab Service with well-maintained AC cars, experienced chauffeurs, flexible pickup options, fixed rates, and comfortable outstation transportation."
  },
  {
    "name": "Bhayandar to Pune Taxi Service",
    "description": "Travel with Bhayandar to Pune Taxi Service offering reliable cabs, professional drivers, affordable fares, airport transfers, corporate travel, and smooth highway journeys."
  },
  {
    "name": "Bhayandar to Pune One Way Cab",
    "description": "Reserve Bhayandar to Pune One Way Cab for direct travel with affordable pricing, doorstep pickup, clean vehicles, experienced chauffeurs, and hassle-free drop service."
  },
  {
    "name": "Bhayandar to Pune Taxi Fare",
    "description": "Check Bhayandar to Pune Taxi Fare with transparent pricing, fixed packages, multiple vehicle choices, and no hidden charges for comfortable travel."
  },
  {
    "name": "Bhayandar to Pune Cab Booking",
    "description": "Complete Bhayandar to Pune Cab Booking online with instant confirmation, multiple car options, secure reservations, and professional chauffeur services."
  },
  {
    "name": "Cab from Bhayandar to Pune",
    "description": "Hire Cab from Bhayandar to Pune for reliable long-distance travel with AC vehicles, luggage space, experienced drivers, and affordable cab packages."
  },
  {
    "name": "Bhayandar to Pune Car Rental",
    "description": "Book Bhayandar to Pune Car Rental for private travel with Sedan, Ertiga, Innova, and premium vehicles available for one way and round trips."
  },
  {
    "name": "Bhayandar to Pune Taxi Booking Online",
    "description": "Reserve Bhayandar to Pune Taxi Booking Online with quick confirmation, flexible timings, transparent fares, and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Cheap Cab Bhayandar to Pune",
    "description": "Choose Cheap Cab Bhayandar to Pune for budget-friendly travel with clean AC cars, professional drivers, affordable rates, and reliable service."
  },
  {
    "name": "Bhayandar to Pune Outstation Cab",
    "description": "Book Bhayandar to Pune Outstation Cab for safe intercity travel with premium vehicles, experienced chauffeurs, fixed pricing, and smooth highway journeys."
  },
  {
    "name": "Bhayandar to Pune AC Taxi Service",
    "description": "Travel comfortably with Bhayandar to Pune AC Taxi Service featuring air-conditioned vehicles, professional drivers, transparent pricing, and convenient pickup facilities."
  },
  {
    "name": "Bhayandar to Pune Innova Cab",
    "description": "Reserve Bhayandar to Pune Innova Cab for family trips, corporate travel, airport transfers, and group journeys with spacious seating and premium comfort."
  },
  {
    "name": "Bhayandar to Pune SUV Taxi",
    "description": "Book Bhayandar to Pune SUV Taxi for luxury and comfortable travel with spacious interiors, experienced chauffeurs, and reliable outstation cab services."
  },
  {
    "name": "Bhayandar to Pune Cab Price",
    "description": "Check Bhayandar to Pune Cab Price with affordable packages, transparent rates, multiple vehicle options, and convenient booking solutions."
  }
],

"tableData": [
  ["Pune to Mira Road Cab", "Bhayandar to Pune Cab"],
  ["Bhayandar to Pune Cab Service", "Bhayandar to Pune Taxi Service"],
  ["Bhayandar to Pune One Way Cab", "Bhayandar to Pune Taxi Fare"],
  ["Bhayandar to Pune Cab Booking", "Cab from Bhayandar to Pune"],
  ["Bhayandar to Pune Car Rental", "Bhayandar to Pune Taxi Booking Online"],
  ["Cheap Cab Bhayandar to Pune", "Bhayandar to Pune Outstation Cab"],
  ["Bhayandar to Pune AC Taxi Service", "Bhayandar to Pune Innova Cab"],
  ["Bhayandar to Pune SUV Taxi", "Bhayandar to Pune Cab Price"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mira Road to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Mira Road to Pune cab services with professional drivers, clean vehicles, and reliable intercity travel solutions for every passenger."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mira Road",
    WhyChoosedescription: "Enjoy convenient pickup from Mira Road East, Mira Road West, railway station, hotels, offices, residential societies, and nearby areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Smooth Mumbai Pune Expressway Travel",
    WhyChoosedescription: "Our experienced chauffeurs ensure a safe and comfortable journey through the Mumbai–Pune Expressway with timely pickup and efficient route planning."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Affordable & Transparent Cab Fare",
    WhyChoosedescription: "Get clear pricing before booking with competitive fares and no hidden charges for your Mira Road to Pune journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Booking",
    WhyChoosedescription: "Book one-way cabs, return trips, airport transfers, or customized travel plans according to your schedule and destination."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Family Travel",
    WhyChoosedescription: "Our Mira Road to Pune cabs are suitable for business meetings, office travel, family vacations, airport transfers, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Book your Mira Road to Pune cab anytime with quick confirmation and dedicated customer support for a hassle-free travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mira Road to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Mira Road to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Mira Road to Pune?",
    answer: "Yes, one-way cab services are available with doorstep pickup from Mira Road and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Mira Road Railway Station?",
    answer: "Yes, pickup is available from Mira Road Railway Station, Mira Road East, Mira Road West, hotels, offices, and residential locations."
  },
  {
    question: "Which vehicles are available for Mira Road to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Is Mira Road to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 according to your preferred travel timing."
  },
  {
    question: "Can I book a return cab from Pune to Mira Road?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Mira Road."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking quotation."
  },
  {
    question: "Should I book my Mira Road to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide Mira Road to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for corporate meetings, employee transportation, client visits, and business travel."
  },
  {
    question: "How can I book Mira Road to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Mehta",
    feedback: "Trustline Travels provided an excellent Mira Road to Pune cab experience. The driver was punctual, the vehicle was clean, and the complete journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Joshi",
    feedback: "The cab booking process was simple and the service quality was impressive. The driver was polite, the car was spacious, and our trip to Pune was safe and relaxing.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mira Road to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/mira-road-to-pune-cab.webp",
  "description":
    "Book Mira Road to Pune Cab with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Mira Road, Bhayandar, and nearby Mumbai locations to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mira-road-to-pune-cab"
  }
};



  return (
    <div>
<Helmet>
  <title>Mira Road to Pune Cab | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mira Road to Pune Cab with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Mira Road, Bhayandar, and nearby Mumbai locations to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 at affordable fares."
  />

  <meta
    name="keywords"
    content="pune to mira road cab, Bhayandar to Pune Cab, Bhayandar to Pune Cab Service, Bhayandar to Pune Taxi Service, Bhayandar to Pune One Way Cab, Mira Road to Pune Cab, Mira Road Pune Taxi, Mira Road to Pune Cab Booking, one way cab mira road to pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Miraroadtopunecab;